// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { ExternalNetworkWebAppClusterWithRelationsSchema } from './ExternalNetworkWebAppClusterRelationsSchema'
import type { ExternalNetworkWebAppClusterWithRelations } from './ExternalNetworkWebAppClusterRelationsSchema'
import { ExternalNetworkWebAppCandidateSchema } from './ExternalNetworkWebAppCandidateSchema';

/////////////////////////////////////////
// EXTERNAL NETWORK WEB APP CANDIDATE RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkWebAppCandidateRelations = {
  surface: ExternalNetworkWithRelations;
  cluster?: ExternalNetworkWebAppClusterWithRelations | null;
};

export type ExternalNetworkWebAppCandidateWithRelations = z.infer<typeof ExternalNetworkWebAppCandidateSchema> & ExternalNetworkWebAppCandidateRelations

export const ExternalNetworkWebAppCandidateWithRelationsSchema: z.ZodType<ExternalNetworkWebAppCandidateWithRelations> = ExternalNetworkWebAppCandidateSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  cluster: z.lazy(() => ExternalNetworkWebAppClusterWithRelationsSchema).nullable(),
}))